module.exports = function installBootstrapLegacyBridge($, bootstrap) {
  window.__bootstrapLegacyBridgeActive = true;

  const DATA_API_MAP = [
    ['data-toggle', 'data-bs-toggle'],
    ['data-target', 'data-bs-target'],
    ['data-dismiss', 'data-bs-dismiss'],
    ['data-parent', 'data-bs-parent']
  ];

  function syncLegacyAttributes(root) {
    const scope = root || document;

    DATA_API_MAP.forEach(([legacyName, modernName]) => {
      scope.querySelectorAll(`[${legacyName}]`).forEach((element) => {
        if (legacyName === 'data-toggle') {
          const toggleValue = element.getAttribute(legacyName);
          if (toggleValue === 'tab' || toggleValue === 'pill') {
            if (element.getAttribute(modernName) === toggleValue) {
              element.removeAttribute(modernName);
            }
            return;
          }
        }

        if (!element.hasAttribute(modernName)) {
          element.setAttribute(modernName, element.getAttribute(legacyName));
        }
      });
    });
  }

  function resolveTarget(element) {
    const selector =
      element.getAttribute('data-bs-target') ||
      element.getAttribute('data-target') ||
      element.getAttribute('href');

    if (!selector || selector.charAt(0) !== '#') {
      return null;
    }

    return document.querySelector(selector);
  }

  function closeLegacyDropdowns(exception) {
    document.querySelectorAll('.dropdown.open').forEach((dropdown) => {
      if (dropdown === exception) {
        return;
      }

      dropdown.classList.remove('open');

      const toggle = dropdown.querySelector('[data-toggle="dropdown"], [data-bs-toggle="dropdown"]');
      if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  function toggleLegacyDropdown(toggle) {
    const dropdown = toggle.closest('.dropdown');
    if (!dropdown) {
      return;
    }

    const willOpen = !dropdown.classList.contains('open');
    closeLegacyDropdowns(willOpen ? dropdown : null);
    dropdown.classList.toggle('open', willOpen);
    toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
  }

  function activateLegacyTab(toggle) {
    const target = resolveTarget(toggle);
    if (!target) {
      bootstrap.Tab.getOrCreateInstance(toggle).show();
      return;
    }

    const currentItem = toggle.closest('li');
    const tabList = toggle.closest('ul:not(.dropdown-menu), ol:not(.dropdown-menu)');
    const wizard = toggle.closest('#wizard');
    const wizardToggles = tabList
      ? Array.from(tabList.querySelectorAll('a[data-toggle="tab"], a[data-toggle="pill"]'))
      : [];
    const visibleWizardToggles = wizardToggles.filter((link) => {
      const item = link.closest('li');
      return !item || item.offsetParent !== null;
    });
    const previousToggle = tabList
      ? tabList.querySelector('li.active > a, a.active[data-toggle="tab"], a.active[data-toggle="pill"]')
      : null;
    const indexSource = wizard ? visibleWizardToggles : wizardToggles;
    const nextIndex = previousToggle ? indexSource.indexOf(toggle) : -1;
    const previousIndex = previousToggle ? indexSource.indexOf(previousToggle) : -1;

    if (currentItem && currentItem.classList.contains('disabled')) {
      const isImmediateWizardStep = wizard && previousToggle && nextIndex === previousIndex + 1;
      if (!isImmediateWizardStep) {
        return;
      }
    }

    if (target.classList.contains('active') && currentItem && currentItem.classList.contains('active')) {
      return;
    }

    const showEvent = $.Event('show.bs.tab', { relatedTarget: previousToggle });
    $(toggle).trigger(showEvent);
    if (showEvent.isDefaultPrevented() || showEvent.result === false) {
      return;
    }

    if (wizard && previousToggle && nextIndex !== -1 && previousIndex !== -1) {
      if (nextIndex === previousIndex + 1) {
        previousToggle.classList.add('pills-success');
      } else if (nextIndex < previousIndex) {
        indexSource.forEach((link, index) => {
          if (index > nextIndex) {
            link.classList.remove('pills-success');
            link.closest('li')?.classList.add('disabled');
          }
        });
      }
    }

    if (tabList) {
      tabList.querySelectorAll('li.active').forEach((item) => {
        item.classList.remove('active');
      });
      tabList.querySelectorAll('a.active').forEach((link) => {
        link.classList.remove('active');
        link.setAttribute('aria-selected', 'false');
      });
    }

    if (currentItem) {
      currentItem.classList.remove('disabled');
      currentItem.classList.add('active');
      const dropdown = currentItem.parentElement?.closest('li.dropdown');
      if (dropdown) {
        dropdown.classList.add('active');
      }
    }
    toggle.setAttribute('aria-selected', 'true');

    const tabContainer = target.parentElement;
    if (tabContainer) {
      Array.from(tabContainer.children).forEach((pane) => {
        if (pane === target || !pane.classList.contains('tab-pane')) {
          return;
        }
        pane.classList.remove('active', 'show', 'in');
      });
    }

    target.classList.add('active', 'show', 'in');

    $(toggle).trigger($.Event('shown.bs.tab', { relatedTarget: previousToggle }));
  }

  function createPlugin(name, Constructor, defaults = {}) {
    $.fn[name] = function bootstrapPlugin(option) {
      const args = Array.prototype.slice.call(arguments, 1);
      let result = this;

      this.each(function bootstrapEach() {
        const config = typeof option === 'object' ? option : defaults;
        const instance = Constructor.getOrCreateInstance(this, config);

        if (typeof option === 'string') {
          if (typeof instance[option] !== 'function') {
            throw new Error(`Unknown Bootstrap ${name} method: ${option}`);
          }

          const response = instance[option](...args);
          if (response !== undefined && response !== instance && result === this) {
            result = response;
          }
        }
      });

      return result;
    };
  }

  createPlugin('alert', bootstrap.Alert);
  createPlugin('collapse', bootstrap.Collapse, { toggle: false });
  createPlugin('modal', bootstrap.Modal);
  createPlugin('tooltip', bootstrap.Tooltip);

  $.fn.tab = function bootstrapTab(option) {
    const args = Array.prototype.slice.call(arguments, 1);
    let result = this;

    this.each(function tabEach() {
      if (typeof option === 'string') {
        if (option === 'show') {
          activateLegacyTab(this);
          return;
        }

        const instance = bootstrap.Tab.getOrCreateInstance(this);
        if (typeof instance[option] !== 'function') {
          throw new Error(`Unknown Bootstrap tab method: ${option}`);
        }

        const response = instance[option](...args);
        if (response !== undefined && response !== instance && result === this) {
          result = response;
        }
        return;
      }

      bootstrap.Tab.getOrCreateInstance(this, option || {});
    });

    return result;
  };

  $.fn.dropdown = function bootstrapDropdown(option) {
    this.each(function dropdownEach() {
      const toggle = this;

      if (typeof option === 'string') {
        if (option === 'toggle') {
          toggleLegacyDropdown(toggle);
        } else if (option === 'show') {
          closeLegacyDropdowns(toggle.closest('.dropdown'));
          toggle.closest('.dropdown')?.classList.add('open');
          toggle.setAttribute('aria-expanded', 'true');
        } else if (option === 'hide') {
          toggle.closest('.dropdown')?.classList.remove('open');
          toggle.setAttribute('aria-expanded', 'false');
        }
        return;
      }

      toggleLegacyDropdown(toggle);
    });

    return this;
  };

  $(document)
    .off('click.bootstrapLegacyBridgeTabs', '[data-toggle="tab"], [data-toggle="pill"]')
    .on(
      'click.bootstrapLegacyBridgeTabs',
      '[data-toggle="tab"], [data-toggle="pill"]',
      function onLegacyTabClick(event) {
        event.preventDefault();
        activateLegacyTab(this);
      }
    );

  $(document)
    .off('click.bootstrapLegacyBridgeWizardPager', '#wizard ul.pager .next a, #wizard ul.pager .previous a')
    .on(
      'click.bootstrapLegacyBridgeWizardPager',
      '#wizard ul.pager .next a, #wizard ul.pager .previous a',
      function onLegacyWizardPagerClick(event) {
        const activeItem = document.querySelector('#wizard ul.nav li.active');
        if (!activeItem) {
          return;
        }

        const siblingSelector = this.closest('li')?.classList.contains('previous')
          ? 'previousElementSibling'
          : 'nextElementSibling';

        let adjacentItem = activeItem[siblingSelector];
        while (adjacentItem && adjacentItem.offsetParent === null) {
          adjacentItem = adjacentItem[siblingSelector];
        }

        const adjacentToggle = adjacentItem?.querySelector('a[data-toggle="tab"], a[data-toggle="pill"]');
        if (!adjacentToggle) {
          return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();
        activateLegacyTab(adjacentToggle);
      }
    );

  syncLegacyAttributes(document);
  window.syncLegacyBootstrapDataApi = syncLegacyAttributes;

  document.addEventListener('click', (event) => {
    const dropdownToggle = event.target.closest('[data-toggle="dropdown"]');
    if (dropdownToggle) {
      event.preventDefault();
      event.stopPropagation();
      toggleLegacyDropdown(dropdownToggle);
      return;
    }

    if (!event.target.closest('.dropdown')) {
      closeLegacyDropdowns();
    }

    const dismissButton = event.target.closest('[data-dismiss="alert"]');
    if (dismissButton) {
      const alert = dismissButton.closest('.alert');
      if (alert) {
        event.preventDefault();
        bootstrap.Alert.getOrCreateInstance(alert).close();
      }
      return;
    }

    const modalDismiss = event.target.closest('[data-dismiss="modal"]');
    if (modalDismiss) {
      const modal = modalDismiss.closest('.modal');
      if (modal) {
        event.preventDefault();
        bootstrap.Modal.getOrCreateInstance(modal).hide();
      }
      return;
    }

    const modalToggle = event.target.closest('[data-toggle="modal"]');
    if (modalToggle) {
      const target = resolveTarget(modalToggle);
      if (target) {
        event.preventDefault();
        bootstrap.Modal.getOrCreateInstance(target).show();
      }
      return;
    }

    const collapseToggle = event.target.closest('[data-toggle="collapse"]');
    if (collapseToggle) {
      const target = resolveTarget(collapseToggle);
      if (target) {
        event.preventDefault();
        bootstrap.Collapse.getOrCreateInstance(target).toggle();
      }
      return;
    }

  });
};
